<template>
  <div class="hold-transition">
    <div class="modal fade" id="modal_form_lista_bloques">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar Listado Bloque</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-6">
                <div class="card card-light m-0">
                  <div class="card-header">
                    <h4 class="card-title">Filtros</h4>
                  </div>
                  <div class="card-body pb-0">
                    <div class="form-group row">
                      <label for="nombre1" class="col-md-5">Nombre</label>
                      <input
                        type="text"
                        id="nombre1"
                        v-model="filtros.nombre"
                        class="form-control form-control-sm col-md-7"
                      />
                    </div>
                    <div class="form-group row">
                      <label for="prefijo1" class="col-md-5">Prefijo</label>
                      <input
                        type="text"
                        id="prefijo1"
                        v-model="filtros.prefijo"
                        class="form-control form-control-sm col-md-7"
                      />
                    </div>
                    <div class="form-group row">
                      <label for="codigo1" class="col-md-5">Codigo</label>
                      <input
                        type="number"
                        id="codigo1"
                        v-model="filtros.codigo"
                        class="form-control form-control-sm col-md-7"
                      />
                    </div>
                    <div class="form-group row">
                      <label for="pais_id" class="col-md-5">Pais</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.pais_id"
                        label="nombre"
                        class="form-control form-control-sm p-0 col-md-7"
                        :options="$parent.listasForms.paises"
                        :filterable="true"
                        :reduce="(p) => p.id"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label for="departamento_id" class="col-md-5"
                        >Departamento</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.departamento_id"
                        label="descripcion"
                        class="form-control form-control-sm p-0 col-md-7"
                        :options="$parent.listasForms.departamentos"
                        :filterable="true"
                        :reduce="(d) => d.id"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label for="ciudad_id" class="col-md-5">Ciudad</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.ciudad_id"
                        label="nombre"
                        class="form-control form-control-sm p-0 col-md-7"
                        :options="$parent.listasForms.ciudades"
                        :filterable="true"
                        :reduce="(c) => c.id"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label for="estado1" class="col-md-5">Estado</label>
                      <v-select
                        id="estado1"
                        class="form-control form-control-sm col-md-7 p-0"
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.estado"
                        label="descripcion"
                        :options="$parent.listasForms.estados"
                        :reduce="(e) => e.id"
                      >
                      </v-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card card-light">
                  <div class="card-header">
                    <h4 class="card-title">Columnas</h4>
                  </div>
                  <div class="card-body">
                    <div class="row justify-content-beetween">
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="nombre"
                            v-model="form.nombre"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="nombre"
                            >Nombre</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="prefijo"
                            v-model="form.prefijo"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="prefijo"
                            >Prefijo</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="codigo"
                            v-model="form.codigo"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="codigo"
                            >Código</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="pais_id"
                            v-model="form.pais_id"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="pais_id"
                            >Pais</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="ciudad_id"
                            v-model="form.ciudad_id"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="ciudad_id"
                            >Ciudad</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="departamento_id"
                            v-model="form.departamento_id"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="departamento_id"
                            >Departamento</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="direccion"
                            v-model="form.direccion"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="direccion"
                            >Dirección</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="justificacion"
                            v-model="form.justificacion"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="justificacion"
                            >Justificación</label
                          >
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="estado"
                            v-model="form.estado"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="estado"
                            >Estado</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-sm bg-olive float-right"
                  @click="generarListadoExcel()"
                  v-if="$store.getters.can('admin.bloques.export')"
                >
                  Generar Listado
                  <i class="fas fa-file-excel"> </i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";

export default {
  name: "BloqueExport",

  components: {
    vSelect,
  },

  data() {
    return {
      form: {
        nombre: true,
        prefijo: true,
        codigo: true,
        pais_id: true,
        ciudad_id: true,
        departamento_id: true,
        direccion: true,
        justificacion: true,
        estado: true,
      },
      filtros: {
        nombre: null,
        prefijo: null,
        codigo: null,
        pais_id: null,
        ciudad_id: null,
        departamento_id: null,
        estado: null,
      },
    };
  },

  methods: {
    getSelectCiudades() {
      this.filtros.ciudad = {};
      this.filtros.ciudad_id = null;
      if (this.ciudad) {
        this.filtros.ciudad = this.ciudad;
        this.filtros.ciudad_id = this.ciudad.id;
      }
    },

    getSelectDepartamentos() {
      this.filtros.departamento = {};
      this.filtros.departamento_id = null;
      if (this.departamento) {
        this.filtros.departamento = this.departamento;
        this.filtros.departamento_id = this.departamento.id;
      }
    },

    generarListadoExcel() {
      this.$parent.cargando = true;
      axios({
        method: "POST",
        url: "/api/admin/bloques/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          this.$parent.cargando = false;
          let data = response.data;

          if (!data.error) {
            this.$swal({
              customClass: {
                container: "my-swal",
              },
              icon: "success",
              title: data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            location.href = data.url;
          } else {
            this.$swal({
              icon: "error",
              title: data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },
  },
};
</script>
